'use client';

import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { useEffect } from 'react';

import { env } from '@/configs/env';

let faroInitialized = false;

export function FaroProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (faroInitialized) return;
    if (typeof window === 'undefined') return;
    // Guard against placeholders / unset secrets — Faro only initializes when
    // the collector URL is a real http(s) endpoint.
    if (!env.NEXT_PUBLIC_FARO_URL?.startsWith('http')) return;
    if (!env.NEXT_PUBLIC_FARO_APP_NAME) return;

    // Faro Web Tracing auto-instruments fetch + XMLHttpRequest and injects
    // W3C `traceparent` on requests to the configured origins. The landing
    // page doesn't talk to the API directly, so propagation is unused here —
    // we keep TracingInstrumentation on for client-side timing spans (LCP,
    // navigation, resource).
    initializeFaro({
      url: env.NEXT_PUBLIC_FARO_URL,
      app: {
        name: env.NEXT_PUBLIC_FARO_APP_NAME,
        version: env.NEXT_PUBLIC_APP_VERSION ?? 'dev',
        environment: env.NEXT_PUBLIC_FARO_APP_ENV ?? 'production',
      },
      instrumentations: [
        ...getWebInstrumentations({ captureConsole: true }),
        new TracingInstrumentation(),
      ],
    });

    faroInitialized = true;
  }, []);

  return <>{children}</>;
}
